import {Component, inject} from '@angular/core';
import {CommunityService} from '../../../../services/community.service';
import { AsyncPipe } from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import {Community} from '../../classes/community';
import {Router} from '@angular/router';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {
  RequestAccessModalComponent,
} from '../../../../shared/components/request-access-modal/request-access-modal.component';
import {filter, Observable, switchMap} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../../services/auth.service';
import {map} from 'rxjs/operators';
import {GenRoleDefinition} from '../../../../generated/serverModels/GenRoleDefinition';
import {FileUploadComponent} from '../../modals/file-upload/file-upload.component';
import { SNACKBAR_DURATION } from '../../../../shared/constants/snackbar.constants';

@Component({
    selector: 'tgrid-community-landing',
    imports: [
    AsyncPipe,
    MatCardModule,
    MatButtonModule,
],
    templateUrl: './community-landing.component.html',
    styleUrl: './community-landing.component.scss',
})
export class CommunityLandingComponent {
  private communityService = inject(CommunityService);
  private router = inject(Router);
  private dialog = inject(MatDialog);
  private snackbar = inject(MatSnackBar);

  public communities$ = this.communityService.getAllCommunities();

  // Should this be a signal?
  public canUpload$: Observable<boolean> = AuthService.authenticatedUser
    .pipe(
      map(user => {
        if (!user) return false;
        return user.hasRole(GenRoleDefinition.ROLE_GDO);
      }),
    );


  public goToCommunity(community: Community): void {
    // noinspection JSIgnoredPromiseFromCall
    this.router.navigate([`app/communities/${community.id}`]);
  }

  public requestAccess(event: MouseEvent, community: Community): void {
    event.stopPropagation();
    this.dialog.open(RequestAccessModalComponent, {
      data: community.displayName,
      width: '400px',
    })
      .afterClosed()
      .pipe(
        filter(reason => !!reason),
        switchMap(reason => this.communityService.requestCommunityAccess(community, reason)),
      )
      .subscribe({
        next: () => {
          this.snackbar.open(`requested access to ${community.displayName} `, 'X', { duration: SNACKBAR_DURATION.MEDIUM });
        },
        error: (error) => {
          console.error(error);
        },
      });
  }

  public openUploadModal(): void {
    const config: MatDialogConfig = {
      disableClose: true,
      width: '500px',
      data: {
        communities: this.communities$,
      },
    };
    this.dialog.open(FileUploadComponent, config).afterClosed()
      .pipe(filter(fileNames => !!fileNames))
      .subscribe((fileNames: string[]) => {
        const plural = (fileNames.length === 1)? 'file': 'files';
        this.snackbar.open(`Successfully uploaded ${fileNames.length} ${plural}`, 'X', { duration: SNACKBAR_DURATION.LONG });
      });
  }
}
